export var itemMixin = {
    data: () => {
        return {
            itemQuery: {fabricante:'', grupo: '', marca: '', descricao: '',codigo:'',ncm:'', page:1},
            itemsList : [],
            selectedItem: {},
            selectedHeaderOptions : [
                { text: "CODIGO", value: "CODIGO" },
                { text: "DESCRIÇÃO", value: "DESCRICAO" },
                { text: "IMAGEM", value: "imagens.image_name" },
                { text: "UM", value: "UM" },
                { text: "MARCA", value: "MARCA" },
                { text: "GRUPO", value: "NOMEGRUPO" },
                { text: "PREÇO VAREJO", value: "PRECOVAREJO" },
                { text: "PREÇO ATACADO", value: "PRECOATACADO" },
                { text: "SALDO", value: "SALDOITEM", align: 'center', },
            ],
            itemPagination: {
                currentPage : 1,
                lastPage: 1,
                perPage:10
            },            
        }
    },
    methods:{
        selectItem(event){
            if(event.value){
                this.selectedItem = event.item;
                console.log(event.item);
            }
        },
        // formatCurrency(value, cifrao, style = 'currency'){
        //     let retorno;
        //     switch(cifrao) {
        //         case 'R$':
        //             retorno =  new Intl.NumberFormat("pt-BR", { style: style, currency: "BRL" }).format(value)
        //         break;
        //         case 'G$':
        //             retorno =  new Intl.NumberFormat("es-PY",{ style: style, currency: "PYG" }).format(value)
        //         break;
        //         case 'U$':
        //             retorno =  new Intl.NumberFormat("en-US",{ style: style, currency: "USD" }).format(value)
        //         break;
        //         case 'P$':
        //             retorno =  new Intl.NumberFormat("es-AR",{ style: style, currency: "ARS" }).format(value)
        //         break;
        //         case 'E$':
        //             retorno =  new Intl.NumberFormat({ style: style, currency: "EUR" }).format(value)
        //         break;
        //         case null:
        //             retorno =  new Intl.NumberFormat("pt-BR",{ style: "decimal"}).format(value)
        //         break;
        //     }
        //     return retorno;
        // }
    }
}